'use client';
import { FC } from 'react';
import styles from './EventsBlock.module.scss';
import { EventArrElement } from '@/models/EventModels';
import EventCard from '@/shared/EventCard';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';

interface EventsBlockProps {
  className?: string;
  title: string;
  events: EventArrElement[];
  allLink?: string;
  isMain?: boolean;
}

const EventsBlock: FC<EventsBlockProps> = ({
  className = '',
  title,
  events,
  allLink,
  isMain = false,
}) => {
  const t = useTranslations('BURGER_MENU');
  const location = usePathname();

  return (
    <div className={`${styles.root}  ${className}`}>
      <div className={styles.header}>
        <h2 className={styles.title}>{t(title)}</h2>
        {allLink && (
          <Link className={styles.header__link} prefetch={false} href={allLink}>
            {t('all')}
          </Link>
        )}
      </div>

      <div className={`${styles.events} ${isMain && styles.events__main}`}>
        {events &&
          events.length > 0 &&
          events.map((event, idx) => (
            <EventCard comeFrom={location} key={idx} event={event} order={idx} />
          ))}
      </div>
    </div>
  );
};

export default EventsBlock;
